/**
 * atomberg-pdp-thumbnail-sync.js
 *
 * Horizon's slideshow-component centers the active thumbnail when the slide
 * changes via an arrow click (select()) or a JS-simulated pointer drag
 * (onPointerUp) — both call #centerSelectedThumbnail(). But a native
 * touch-scroll (the browser's own scroll-snap physics settling after a
 * finger swipe, handled by #handleScroll -> #sync()) updates the current
 * index and fires a `slideshow:select` event with `trigger: 'scroll'`
 * WITHOUT ever calling that centering method — so swiping through images
 * leaves the thumbnail strip's active item off-screen. That's Horizon's
 * own gap, not something this file's targets duplicate: click/drag
 * already work, so this only handles the 'scroll' trigger to avoid a
 * second competing scroll animation on paths that already center correctly.
 *
 * `refs` is a public property on Shopify's Component base class, so the
 * dispatching slideshow-component (event.target) exposes the same
 * thumbnail/container elements Horizon's own method reads internally —
 * no private API access needed.
 */
(function () {
  if (/** @type {any} */ (window)._atombergPdpThumbnailSyncInit) return;
  /** @type {any} */ (window)._atombergPdpThumbnailSyncInit = true;

  document.addEventListener('slideshow:select', function (e) {
    var detail = /** @type {any} */ (e).detail;
    if (!detail || detail.trigger !== 'scroll') return;

    var component = /** @type {any} */ (e.target);
    var refs = component && component.refs;
    if (!refs) return;

    var thumbnails = /** @type {HTMLElement[] | undefined} */ (refs.thumbnails);
    var container = /** @type {HTMLElement | undefined} */ (refs.thumbnailsContainer);
    var target = thumbnails && thumbnails[detail.index];
    if (!target || !container) return;

    target.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
  });
})();
